/**
 * Classe que cria e gerencia as imagens de assinaturas
 * @author: Daniel Laurindo
 * @Date: 06/06/2013
 *
 */


Greenmile.Gallery = Greenmile.Gallery || {};

Greenmile.Gallery.Signature = (function () {

    function signatureGallery (idRota, keyStop) {

        Monet.GenericModal.apply(this, arguments);

        this.idRota = idRota;
        this.keyStop = keyStop;

        var screenTab = Monet.Utils.GetTabName(),
            menu      = document.querySelector('#' + screenTab + ' .MonetUIFloatMenu'),
            parent;

        if (menu) {
            parent = menu.parentNode;
            parent.removeChild(menu);
        }

        this.listeners = function () {

            try {

                this.iconLoading();
                
                const ajax = new Monet.Ajax();

                const parsedStopKey = Greenmile.Stop.Util.formatStopKey(this.keyStop);

                ajax.url = `Route/${this.idRota}/Stop/${parsedStopKey}/Signature`;
                ajax.method = 'GET';
                ajax.success = (data) => {
                    $('.loadingPopupFormContainer').remove();
                    this.generateModalContent(data);
                };
                ajax.error = (xhr, ajaxOptions, thrownError) => {
                    this.errorCallback(xhr, ajaxOptions, thrownError);
                };
                ajax.send();

            } catch (e) {
                var error = new Monet.Exception.ReturnError(this, "Image not found.");
                error.console();
            }

        };

        this.generateModalContent = function (data) {
            var template = Greenmile.Templates.getSignatureContainer(data);
            var signature_element = document.createElement("div");

            signature_element.setAttribute("class", "popup_signature");

            if ($(".popupFormContainer .popup_signature").length > 0) {
                $(".popupFormContainer .popup_signature").remove();
            }

            $(".popupFormContainer").append(signature_element);
            $(".popupFormContainer .popup_signature").append(template);

        };

        this.addEventListeners = () => {
            this.listeners();
        };

        this.createAllStructure = () => {

                this.addEventListeners();

        };

    }

    return signatureGallery;

})();